// import axios from "axios";
// import { GET_CODING_STATS, GET_LANGUAGE_LEVELS, GET_SUB_LEVELS, POST_SUGGESTION } from "../../utils/api";
// import {
//   CODING_STATS_FAILURE,
//   CODING_STATS_SUCCESS,
//   GET_LANGUAGES_FAILURE,
//   GET_LEVEL_CONTENT_FAILURE,
//   GET_LEVEL_CONTENT_SUCCESS,
//   GET_SUB_LEVEL_CONTENT_FAILURE,
//   GET_SUB_LEVEL_CONTENT_SUCCESS,
//   SUGGESTION_FAILURE,
//   SUGGESTION_SUCCESS,
// } from "./code.actionTypes";

// export const getLevelsContent = (language, level) => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };

//   try {
//     const resp = await axios.get(`${GET_LANGUAGE_LEVELS}/${language}/${level}`, {
//       headers,
//       withCredentials: true,
//     });
    
//     if (resp.status === 200) {
//       dispatch({
//         type: GET_LEVEL_CONTENT_SUCCESS,
//         payload: resp.data,
//       });
//       return resp.data;
//     } else {
//       dispatch({
//         type: GET_LEVEL_CONTENT_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     console.error("Unable to process request. Please try later!", error);
//     dispatch({
//       type: GET_LANGUAGES_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const getSublevels = (payload) => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };

//   try {
//     const resp = await axios.get(`${GET_SUB_LEVELS}/${payload.lang}/${payload.level}/${payload.sublevel}`, {
//       headers,
//       withCredentials: true,
//     });
//     if (resp.status === 200) {
//       dispatch({
//         type: GET_SUB_LEVEL_CONTENT_SUCCESS,
//         payload: resp.data,
//       });
//       return resp.data.sublevels;
//     } else {
//       dispatch({
//         type: GET_SUB_LEVEL_CONTENT_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     console.error("Unable to process request. Please try later!", error);
//     dispatch({
//       type: GET_LANGUAGES_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const getSuggestion = (data) => async (dispatch) => {
//    const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "Content-Type": "application/json",
//   };
//   try {
//     const resp = await axios.post(POST_SUGGESTION, data, {
//       headers,
//       withCredentials: true,
//     });
//     if (resp.status === 200) {
//       dispatch({
//         type: SUGGESTION_SUCCESS,
//         payload: resp.data.suggestions,
//       });
//     } else {
//       dispatch({
//         type: SUGGESTION_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     console.error("Unable to process request. Please try later!", error);
//     dispatch({
//       type: SUGGESTION_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };



// export const getCodingStats = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };

//   try {
//     const resp = await axios.get(`${GET_CODING_STATS}`, {
//       headers,
//       withCredentials: true,
//     });
    
//     if (resp.status === 200) {
//       dispatch({
//         type: CODING_STATS_SUCCESS,
//         payload: resp.data,
//       });
//       return resp.data;
//     } else {
//       dispatch({
//         type: CODING_STATS_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     console.error("Unable to process request. Please try later!", error);
//     dispatch({
//       type: CODING_STATS_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };


import { apiRequest } from "../../api/apiRequest";
import { GET_CODING_STATS, GET_LANGUAGE_LEVELS, GET_SUB_LEVELS, POST_SUGGESTION } from "../../utils/api";
import {
  CODING_STATS_FAILURE,
  CODING_STATS_SUCCESS,
  GET_LANGUAGES_FAILURE,
  GET_LEVEL_CONTENT_FAILURE,
  GET_LEVEL_CONTENT_SUCCESS,
  GET_SUB_LEVEL_CONTENT_FAILURE,
  GET_SUB_LEVEL_CONTENT_SUCCESS,
  SUGGESTION_FAILURE,
  SUGGESTION_SUCCESS,
} from "./code.actionTypes";

export const getLevelsContent = (language, level) => async (dispatch) => {
  const result = await apiRequest("get", `${GET_LANGUAGE_LEVELS}/${language}/${level}`);

  if (result.success) {
    dispatch({
      type: GET_LEVEL_CONTENT_SUCCESS,
      payload: result.data,
    });
    return result.data;
  } else {
    console.error("Unable to process request. Please try later!", result.message);
    dispatch({
      type: GET_LEVEL_CONTENT_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const getSublevels = (payload) => async (dispatch) => {
  const result = await apiRequest(
    "get",
    `${GET_SUB_LEVELS}/${payload.lang}/${payload.level}/${payload.sublevel}`
  );

  if (result.success) {
    dispatch({
      type: GET_SUB_LEVEL_CONTENT_SUCCESS,
      payload: result.data,
    });
    return result.data.sublevels;
  } else {
    console.error("Unable to process request. Please try later!", result.message);
    dispatch({
      type: GET_SUB_LEVEL_CONTENT_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const getSuggestion = (data) => async (dispatch) => {
  const result = await apiRequest("post", POST_SUGGESTION, data);

  if (result.success) {
    dispatch({
      type: SUGGESTION_SUCCESS,
      payload: result.data.suggestions,
    });
  } else {
    console.error("Unable to process request. Please try later!", result.message);
    dispatch({
      type: SUGGESTION_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const getCodingStats = () => async (dispatch) => {
  const result = await apiRequest("get", GET_CODING_STATS);

  if (result.success) {
    dispatch({
      type: CODING_STATS_SUCCESS,
      payload: result.data,
    });
    return result.data;
  } else {
    console.error("Unable to process request. Please try later!", result.message);
    dispatch({
      type: CODING_STATS_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};